import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { createUseStyles } from 'react-jss';
import SignInInputWithLabel from './SignInInputWithLabel';
import AuthFormButton from './AuthFormButton';
import { RESET_PASSWORD } from '../../redux/authReducer';
import AuthFormContainer from './AuthFormContainer';
import { compose } from 'redux';
import withScopedTranslations from '../../withScopedTranslations/withScopedTranslations';
import { SET_MODAL } from '../../redux/Modal';

const ResetPasswordForm = ({ t, resetPassword, setModal, passwordUpdated, match: { params: { token, }, }, }) => {
  const classes = useStyles();
  const [formFields, setFromFields] = useState({ password: '', password_confirmation: '', });
  const onFieldChange = (value, filedName) => {
    setFromFields({ ...formFields, [filedName]: value, });
  };
  const error = () => {
    const regex = /^(?=.*[!@#$%^&*])(?=.*[A-Z])(?=.*[a-z]).+$/;
    // Contains at least 1 special character
    // Contains at least 1 uppercase letter
    // Contains at least 1 lowercase letter
    if (formFields.password.length === 0 && formFields.password_confirmation.length === 0) {
      return false
    }
    if (formFields.password !== formFields.password_confirmation) {
      return true
    }
    return !regex.test(formFields.password);
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    if (error()) {
      return null;
    }
    return resetPassword({ ...formFields, token, });
  };

  const getErrormessage = () => {
    if (formFields.password.length < 8) {
      return t('password_too_short')
    }
    return formFields.password === formFields.password_confirmation ? t('password_not_meet_requirements') : t('password_not_mach')
  }

  if (passwordUpdated) {
    setModal({ componentName: 'PasswordUpdatedModal', isCloseButtonShown: false, });
  }
  return (
    <AuthFormContainer>
      <form className={classes.resetPasswordForm} onSubmit={handleSubmit}>
        <SignInInputWithLabel
          labelText={t('password')}
          filedName="password"
          type="password"
          onChange={onFieldChange}
          value={formFields.password}
          error={error()}
          errorMessage={getErrormessage()}
        />
        <SignInInputWithLabel
          labelText={t('password_confirmation')}
          filedName="password_confirmation"
          type="password"
          onChange={onFieldChange}
          value={formFields.password_confirmation}
          error={error()}
          errorMessage={getErrormessage()}
        />
        <a
          href="/dashboard/auth/sign-in"
          className={classes.formTrouble}
        >
          {t('password_alerady_resset')}
        </a>
        <AuthFormButton text={t('save')} />
      </form>
    </AuthFormContainer>
  );
};

ResetPasswordForm.propTypes = {
  t: PropTypes.func.isRequired,
  match: PropTypes.object.isRequired,
  resetPassword: PropTypes.func.isRequired,
  passwordUpdated: PropTypes.bool.isRequired,
  setModal: PropTypes.func.isRequired,
};

const useStyles = createUseStyles({
  resetPasswordForm: {
    fontSize: '13px',
    fontWeight: '700',
    color: '#b0acb7',
    marginTop: '2.5em',
    textAlign: 'left',
  },
  formTrouble: {
    textDecoration: 'none',
    color: '#57C2EF',
    fontWeight: '700',
    fontSize: '14px',
  },
});

const mapDispatchToProps = (dispatch) => {
  return {
    resetPassword: (params) => dispatch(RESET_PASSWORD(params)),
    setModal: (params) => dispatch(SET_MODAL(params)),
  };
};

const mapStateToProps = (state) => {
  return {
    passwordUpdated: state.authReducer.passwordUpdated,
  }
}

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withScopedTranslations('signIn')
)(ResetPasswordForm);
